import { AppTagItemEntity } from '@datachain/ui-sdk/components/dc-types';
import { immerable } from 'immer';
import { OrderedSet } from 'immutable';

export interface IProjectItemEntity {
	id: number;
	label: string;
	description: string;
	tags: OrderedSet<AppTagItemEntity>;
}

const entityDefaults: IProjectItemEntity = {
	id: -1,
	label: '',
	description: '',
	tags: OrderedSet(),
};

export class SubscriptionProjectItemEntity implements IProjectItemEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public label = entityDefaults.label;
	public description = entityDefaults.description;
	public tags = entityDefaults.tags;

	public static build(
		params: Partial<IProjectItemEntity> = {}
	): SubscriptionProjectItemEntity {
		const instance = new SubscriptionProjectItemEntity();
		instance.id = params.id ?? entityDefaults.id;
		instance.label = params.label ?? entityDefaults.label;
		instance.description = params.description ?? entityDefaults.description;
		instance.tags = params.tags ?? entityDefaults.tags;

		return instance;
	}
}
